import type { FaireProductEntity } from "../../entity_types/product";

export const p_cpbdy5rxgh: FaireProductEntity = {
  token: "p_cpbdy5rxgh",
  type: "product",
  name: "Taiyo 18K Gold Non-Tarnish Boho Sun Necklace",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl:
    "https://cdn.faire.com/fastly/13f2e96073641c9ba3a8710686dc4b1ceef5bce6bfd7ae9dc21db52e1cb022aa.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/99e127c051e13fddfef5ec6589e9aa74aa282f8b08b287093b5bc1752ce559a5.jpeg",
    "https://cdn.faire.com/fastly/c824e5a3203ee8d334040150e796fd7e2a1df8b29bef3f67bf3ed3ae1a1ff650.jpeg",
    "https://cdn.faire.com/fastly/f8c5b5e16c3e38c528cdf4cf0e1ec8f88f8ce84af94d2c74b00cd02d60ac8b8d.jpeg",
    "https://cdn.faire.com/fastly/5d140229a277d2dde751a305bdd5481080e1449fc26cfbe8ca02998ce6da064b.jpeg",
    "https://cdn.faire.com/fastly/942acdf8aff1f6398ce43696b021e2c7c6b80c856e30c4fc39cad1f9536c3787.jpeg",
  ],
  priceDollars: 5.44,
  description:
    "18K Gold Non-Tarnish Boho Sun Necklace\n18K Gold Plated\nStainless Steel\nPendant Size (inch): 1.5\nChain Length (inch): 15.57\nExtension Length (inch): 2\n\n• Lead-free, Nickel-safe\n• Hypoallergenic\n• Water Resistant",
  tags: [],
  msrpDollars: 19.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:04.620Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
